import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="site-header">
      <div className='site-header__inner'>

        <div className="site-header__logo">
          <a href="/" className='site-header_title'>Build to grow</a> 
          <p className='site-header_subtitle'>Tracking progress towards 150 major infrastructure projects</p> 
        </div>

        <nav className="site-header__nav">
        </nav>
      </div>
    </header>
  );
}

export default Header;
